import React, { useEffect, useState } from 'react';
import GenericNavBar from 'newComponents/GenericNavBar';

import { useTour } from 'hooks/useTour';
import {
  Container,
  PageTitle,
  Separator,
  ButtonsWrap,
  ButtonNavigator,
} from './styles';
import FormProfile from './FormProfile';
import FormUser from './FormUser';
import { EFormProfileStatus } from './enum';
import Contract from './Contract';
import Addendum from './Addendum';
import { TableWrap } from '../BankSlip/styles';
import TourBalloon from '../../newComponents/NewTour/TourBallon';

const Profile: React.FC = () => {
  const [activeTable, setActiveTable] = useState<string>(
    EFormProfileStatus.profile
  );

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    setTourType('profile');
    setSteps(2);
  }, [showTour, setTourType, setSteps]);

  useEffect(() => {
    // if (showTour && tourType === 'profile' && tourStep >= 2) {
    //   const el = document.getElementById('form-user');
    //   el?.scrollIntoView();
    // }
    if (showTour && tourType === 'profile' && tourStep < 2) {
      const el = document.getElementById('user-menu');
      if (el) {
        el.scrollIntoView();
      }
    }
  }, [showTour, tourType, tourStep]);

  return (
    <GenericNavBar breadcrump="› Perfil" selected="Perfil" intro={() => true}>
      <Container>
        <PageTitle>Perfil</PageTitle>
        <Separator />
        <TableWrap
          showTour={showTour && tourType === 'profile' && tourStep === 1}
        >
          <ButtonsWrap>
            <ButtonNavigator
              onClick={() => {
                setActiveTable(EFormProfileStatus.profile);
              }}
              active={activeTable === EFormProfileStatus.profile}
            >
              Dados cadastrais
            </ButtonNavigator>
            <ButtonNavigator
              onClick={() => {
                setActiveTable(EFormProfileStatus.contracts);
              }}
              active={activeTable === EFormProfileStatus.contracts}
            >
              Contratos
            </ButtonNavigator>
            <ButtonNavigator
              onClick={() => {
                setActiveTable(EFormProfileStatus.addendum);
              }}
              active={activeTable === EFormProfileStatus.addendum}
            >
              Adendos
            </ButtonNavigator>
          </ButtonsWrap>
          {showTour && tourType === 'profile' && tourStep === 1 && (
            <TourBalloon
              title="Menu de navegação"
              content="Aqui você pode navegar entre as opções Dados cadastrais, Contratos e Adendos"
              position={{
                left: '0%',
                right: '0',
                top: '95%',
                arrowPosition: 'top',
                maxWidth: null,
                boxShadow: false,
              }}
            />
          )}
        </TableWrap>
        {activeTable === EFormProfileStatus.profile && (
          <TableWrap
            showTour={showTour && tourType === 'profile' && tourStep === 2}
          >
            <FormProfile />
            <PageTitle>Dados do usuário</PageTitle>
            <Separator />
            <FormUser id="form-user" />
            {showTour && tourType === 'profile' && tourStep === 2 && (
              <TourBalloon
                title="Dados cadastrais"
                content="Aqui você encontra as informações do seu cadastro de perfil, você pode realizar a troca de senha clicando em Alterar senha"
                position={{
                  left: '30%',
                  right: '0',
                  top: '-212px',
                  width: '342px',
                  arrowPosition: 'bottom',
                  maxWidth: 'unset',
                  boxShadow: false,
                }}
              />
            )}
          </TableWrap>
        )}
        {activeTable === EFormProfileStatus.contracts && (
          <TableWrap
            showTour={
              showTour &&
              tourType === 'profile' &&
              tourStep === 2 &&
              activeTable === EFormProfileStatus.contracts
            }
          >
            <Contract />
            {showTour &&
              tourType === 'profile' &&
              tourStep === 2 &&
              activeTable === EFormProfileStatus.contracts && (
                <TourBalloon
                  title="Contratos"
                  content="Aqui você encontra os contratos atrelados a sua conta."
                  position={{
                    left: '30%',
                    right: '0',
                    top: '-190px',
                    arrowPosition: 'bottom',
                    maxWidth: 'unset',
                    width: '300px',
                    boxShadow: false,
                  }}
                />
              )}
          </TableWrap>
        )}
        {activeTable === EFormProfileStatus.addendum && (
          <TableWrap
            showTour={
              showTour &&
              tourType === 'profile' &&
              tourStep === 2 &&
              activeTable === EFormProfileStatus.addendum
            }
          >
            <Addendum />
            {showTour &&
              tourType === 'profile' &&
              tourStep === 2 &&
              activeTable === EFormProfileStatus.addendum && (
                <TourBalloon
                  title="Adendos"
                  content="Aqui você encontra os adendos atrelados a sua conta."
                  position={{
                    left: '30%',
                    right: '0',
                    top: '-190px',
                    arrowPosition: 'bottom',
                    maxWidth: 'unset',
                    width: '300px',
                    boxShadow: false,
                  }}
                />
              )}
          </TableWrap>
        )}
      </Container>
    </GenericNavBar>
  );
};

export default Profile;
